import api from './client';
import type { TrackerDomain } from './tracker-types';

export const getDomains = () => api.get<TrackerDomain[]>('/admin/tracker/domains');
export const getDomain = (id: string) => api.get<TrackerDomain>(`/admin/tracker/domains/${id}`);
export const createDomain = (hostname: string) => api.post<TrackerDomain>('/admin/tracker/domains', { hostname });
export const refreshDomain = (id: string) => api.post<TrackerDomain>(`/admin/tracker/domains/${id}/refresh`);
export const deleteDomain = (id: string) => api.delete<{ message: string }>(`/admin/tracker/domains/${id}`);

/** Hand a pool domain to a client company, or take it back (null). Staff only. */
export const setDomainClient = (id: string, clientId: string | null) =>
  api.put<TrackerDomain>(`/admin/tracker/domains/${id}/client`, { client_id: clientId });
